import React from 'react';

import { Grid } from '@gogame/components';
import { FormField, withFormFieldGroupFormField } from '@gogame/form';

import { useExtraContext } from 'scenes/SmartRules/SmartRuleForm/ExtraContext';
import {
  loadAffectedLevel,
  loadSecondaryAffectedLevel,
} from 'scenes/SmartRules/sources/fields';

import { SecondaryAffectedLevel } from './SecondaryAffectedLevel';
import {
  GENERAL,
  NAME,
  AFFECTED_LEVEL,
  SECONDARY_AFFECTED_LEVEL,
} from './constants';
import { generalValidationSchema } from './schemas';

export const General = withFormFieldGroupFormField({
  name: GENERAL,
  validationSchema: generalValidationSchema,
})(({ isEdit, name, withName = true, value, xs = 4 }) => {
  const {
    isAllowDynamicConditionByAffectedLevel,
    isAllowDynamicConditionBySecondaryAffectedLevel,
  } = useExtraContext();

  const validationName = React.useCallback(
    (value) => {
      if (withName && !value) {
        return 'Name is required';
      }
    },
    [withName]
  );

  return (
    <Grid container spacing={3}>
      {withName ? (
        <Grid item xs={xs}>
          <FormField.TextField
            label={'Name'}
            name={NAME}
            required={true}
            validate={validationName}
            padding={'0'}
          />
        </Grid>
      ) : null}
      <Grid item xs={xs}>
        <FormField.Select
          label={'Affected level'}
          name={AFFECTED_LEVEL}
          source={loadAffectedLevel}
          lazy={true}
          required={true}
          helperText={
            !isAllowDynamicConditionByAffectedLevel &&
            "This level doesn't support dynamic conditions"
          }
          padding={'0'}
          disabled={isEdit}
        />
      </Grid>
      <Grid item xs={xs}>
        <SecondaryAffectedLevel
          label={'Secondary affected level'}
          name={SECONDARY_AFFECTED_LEVEL}
          depends={[`${name}.${AFFECTED_LEVEL}`]}
          active={!!value?.[AFFECTED_LEVEL]}
          source={loadSecondaryAffectedLevel}
          canDeselect={true}
          helperText={
            !isAllowDynamicConditionBySecondaryAffectedLevel &&
            "This level doesn't support dynamic conditions"
          }
          padding={'0'}
        />
      </Grid>
    </Grid>
  );
});
